
import { Dispatch, SetStateAction, createContext } from "react";

interface ICommonContext {
    helpOpen: boolean;
    setHelpOpen: Dispatch<SetStateAction<boolean>>;
    mobileNavigationDrawerOpen: boolean;
    setMobileNavigationDrawerOpen: Dispatch<SetStateAction<boolean>>;
}

export const CommonContext = createContext<ICommonContext>({
    helpOpen: false,
    setHelpOpen: () => {},
    mobileNavigationDrawerOpen: false,
    setMobileNavigationDrawerOpen: () => {}
});

export default CommonContext;